import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["children", "expandButtonText", "collapseButtonText", "collapsedLines", "onExpandedChange", "dataTestId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { ToggleButton } from '../ToggleButton';
import { useCollapsedHeight, useExpandedHeight, useExpander, useTransitionDurationVar } from '../hooks';
import styles from './ExpanderText.module.css';
import varsStyles from '../styles/vars.module.css';
import { DEFAULT_COLLAPSE_BUTTON_TEXT, DEFAULT_EXPAND_BUTTON_TEXT, DEFAULT_TEXT_TEST_ID, TRANSITION_DURATION } from '../constants';
import { useEventCallback } from '@cian/react-utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ExpanderTextComponent = (_ref, ref) => {
  let {
      children,
      expandButtonText = DEFAULT_EXPAND_BUTTON_TEXT,
      collapseButtonText = DEFAULT_COLLAPSE_BUTTON_TEXT,
      collapsedLines,
      onExpandedChange,
      dataTestId = DEFAULT_TEXT_TEST_ID
    } = _ref,
    restProps = _objectWithoutProperties(_ref, _excluded);
  const contentRef = React.useRef(null);
  const [clampedLines, setClampedLines] = React.useState(collapsedLines);
  const handleExpandedChange = useEventCallback(expanded => {
    if (expanded) {
      setClampedLines(undefined);
    } else {
      /**
       * @description
       * При скрывании контента эффект ellipsis должен появиться только после завершения анимации
       */
      setTimeout(() => {
        setClampedLines(collapsedLines);
      }, TRANSITION_DURATION);
    }
    if (onExpandedChange) {
      onExpandedChange(expanded);
    }
  });
  const {
    expanded,
    onToggle,
    size
  } = useExpander(_objectSpread({
    onExpandedChange: handleExpandedChange
  }, restProps));
  const expandedHeight = useExpandedHeight(contentRef);
  const collapsedHeight = useCollapsedHeight(contentRef);
  useTransitionDurationVar(contentRef);
  return /*#__PURE__*/_jsxs("div", {
    className: varsStyles['expander'],
    "data-testid": dataTestId,
    ref: ref,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles['content'],
      ref: contentRef,
      style: {
        maxHeight: expanded ? expandedHeight : collapsedHeight,
        WebkitLineClamp: clampedLines
      },
      children: children
    }), /*#__PURE__*/_jsx("div", {
      className: styles['toggle-container'],
      children: /*#__PURE__*/_jsx(ToggleButton, {
        expanded: expanded,
        onToggle: onToggle,
        size: size,
        expandButtonText: expandButtonText,
        collapseButtonText: collapseButtonText
      })
    })]
  });
};

/**
 * Вариация компонента только для текста с эффектом ellipsis.
 * <br />
 * Работает на основе заданного количества строк collapsedLines, высота свернутого контента рассчитывается автоматически.
 *
 * [Ссылка на макет](https://www.figma.com/design/il7C7QByCaIpFdBZcyhEGv/%F0%9F%8C%90-Expander)
 */
export const ExpanderText = /*#__PURE__*/React.forwardRef(ExpanderTextComponent);